import { OVEntity, OVField, OVSearch, OVTable } from '@ov-suite/ov-metadata';
import { InventoryLocationModel, ProductSkuModel } from '@ov-suite/models-admin';
import { UserModel } from '@ov-suite/models-idm';
import { InventoryContainer } from './inventory-container.model';

@OVEntity('JournalEntity', 'warehouselink')
@OVTable<JournalModel>([
  {
    key: 'date',
    title: 'Date',
    type: 'date-time',
  },
  {
    key: 'type',
    title: 'Type',
    type: 'string',
  },
  {
    key: 'action',
    title: 'Action',
    type: 'string',
  },
  {
    key: 'change',
    title: 'Change',
    type: 'number',
  },
  {
    key: 'productSku.sku',
    title: 'Product SKU',
    type: 'deep-string',
  },
  {
    title: 'From',
    type: 'other',
    keys: ['fromLocation.name', 'fromHeldByUser.firstName', 'fromHeldByUser.lastName'],
    action: item => {
      if (item.fromLocation?.name) {
        return item.fromLocation.name;
      }
      if (item.fromHeldByUser) {
        return `${item.fromHeldByUser.firstName} ${item.fromHeldByUser.lastName}`.trim();
      }
      return '';
    },
  },
  {
    title: 'To',
    type: 'other',
    keys: ['toLocation.name', 'toHeldByUser.firstName', 'toHeldByUser.lastName'],
    action: item => {
      if (item.toLocation?.name) {
        return item.toLocation.name;
      }
      if (item.toHeldByUser) {
        return `${item.toHeldByUser.firstName} ${item.toHeldByUser.lastName}`.trim();
      }
      return '';
    },
  },
  {
    key: 'description',
    title: 'Description',
    type: 'string',
  },
  {
    title: 'Responsible User',
    type: 'other',
    keys: ['responsibleUser.firstName', 'responsibleUser.lastName'],
    action: item => {
      if (!item.responsibleUser) {
        return '';
      }
      return `${item.responsibleUser.firstName} ${item.responsibleUser.lastName}`.trim();
    },
  },
  {
    key: 'container.name',
    title: 'Container',
    type: 'deep-string',
  },
])
@OVSearch<JournalModel>({
  searchKeys: [
    'description',
    'type',
    'action',
    'productSku.sku',
    'productSku.name',
    'fromLocation.name',
    'fromHeldByUser.firstName',
    'fromHeldByUser.lastName',
    'toLocation.name',
    'toHeldByUser.firstName',
    'toHeldByUser.lastName',
    'responsibleUser.firstName',
    'responsibleUser.lastName',
    'container.name',
  ],
})
export class JournalModel {
  @OVField({ type: 'number' })
  id: number;

  @OVField({ type: 'string' })
  type: string;

  @OVField({ type: 'string' })
  action: string;

  @OVField({ type: 'number' })
  change: number;

  @OVField({ type: 'number' })
  fromLocationId?: number;

  @OVField({ type: () => InventoryLocationModel })
  fromLocation?: InventoryLocationModel;

  @OVField({ type: 'number' })
  fromHeldByUserId?: number;

  @OVField({ type: () => UserModel })
  fromHeldByUser?: UserModel;

  @OVField({ type: 'number' })
  toLocationId?: number;

  @OVField({ type: () => InventoryLocationModel })
  toLocation?: InventoryLocationModel;

  @OVField({ type: 'number' })
  toHeldByUserId?: number;

  @OVField({ type: () => UserModel })
  toHeldByUser?: UserModel;

  @OVField({ type: 'number' })
  responsibleUserId?: number;

  @OVField({ type: () => UserModel })
  responsibleUser?: UserModel;

  @OVField({ type: 'string' })
  description: string;

  @OVField({ type: 'string' })
  processInstanceId?: string;

  @OVField({ type: 'number' })
  containerId?: number;

  @OVField({ type: 'number' })
  loadId?: number;

  @OVField({ type: () => InventoryContainer })
  container?: InventoryContainer;

  @OVField({ type: 'date-time' })
  date: Date;

  @OVField({ type: 'number' })
  productSkuId?: number;

  @OVField({ type: () => ProductSkuModel })
  productSku?: ProductSkuModel;

  @OVField({ type: 'date-time' })
  createdDate: Date;
}
